const SAFE_SCHEMES = new Set(['http:', 'https:', 'mailto:']);

/** `href` when it is an absolute http(s) or mailto URL; '' otherwise (no `javascript:` links). */
export const safeHref = (href: string | undefined | null): string => {
  if (!href) return '';

  try {
    return SAFE_SCHEMES.has(new URL(href).protocol) ? href : '';
  } catch {
    return '';
  }
};

/**
 * `config.supportEmailAddress` holds either an email address or a help-desk URL, so it
 * can't be prefixed with `mailto:` unconditionally. It is also absent until the config
 * request resolves, which must not produce a `mailto:undefined` link.
 */
export const supportHrefFor = (address: string | undefined | null): string => {
  if (!address) return '';

  const href = address.includes('@') && !/^https?:/i.test(address) ? `mailto:${address}` : address;

  return safeHref(href);
};
